<template>
    <div class="rating">

        <el-popover placement="top" v-if="selectedOption">
            <div slot="reference" :class="'btn-indicator btn-indicator-'+color">
                <div class="btn-section btn-section-4"></div>
                <div class="btn-section btn-section-3"></div>
                <div class="btn-section btn-section-0-top"></div>
                <div class="btn-section btn-section-0-bottom"></div>
                <div class="btn-section btn-section-2"></div>
                <div class="btn-section btn-section-1"></div>
            </div>

            <div>
                <h4>{{ name }}</h4>
                <small class="description">{{ description }}</small>
                <br>
                <base-button :type="selectedOption.color" class="mt-3 btn-round btn-sm" v-if="selectedOption.name">
                    <span class="btn-inner--icon">
                        {{ selectedOption.name }}
                    </span>
                </base-button>
            </div>
        </el-popover>

        <div v-else>
            <div class="btn-section btn-section-4"></div>
            <div class="btn-section btn-section-3"></div>
            <div class="btn-section btn-section-0-top"></div>
            <div class="btn-section btn-section-0-bottom"></div>
            <div class="btn-section btn-section-2"></div>
            <div class="btn-section btn-section-1"></div>
        </div>

    </div>
</template>

<script>
    export default {

        props: {

            name: {
                type: String,
                default: ''
            },

            description: {
                type: String,
                default: ''
            },

            value: {
                type: [Number, String],
                default: -1
            },

            invert: {
                type: Boolean,
                default: false
            },

            options: {
                type: Array,
                required: true
            },
        },

        computed: {

            selectedOption() {
                return this.options[this.value]
            },

            color() {
                return this.selectedOption ? this.selectedOption.color : 'no'
            }
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    .btn-section {
        height: 18px;
    }
    .btn-section-0-top {
        border-bottom: dashed 1px #999;
    }
    .btn-section-0-top, .btn-section-0-bottom {
        height: 9px;
    }
    .btn-section-2, .btn-section-3 {
        height: 9px;
    }
    .btn-indicator {
        cursor: pointer;
    }
    .btn-indicator-success .btn-section-4 {
        background-color: #2dce89;
    }
    .btn-indicator-info .btn-section-3, .btn-indicator-info .btn-section-0-top  {
        background-color: #11cdef;
    }
    .btn-indicator-warning .btn-section-2, .btn-indicator-warning .btn-section-0-bottom {
        background-color: #fbc340;
    }
    .btn-indicator-danger .btn-section-1 {
        background-color: #f5365c;
    }
    .btn-indicator-muted .btn-section-0-top, .btn-indicator-muted .btn-section-0-bottom {
        background-color: #d2e3ee;
    }
    
</style>
